module.exports = __webpack_public_path__ + "static/media/KUV.b5e0063f.pdf";